<!-- 
自定义验证码输入、密码输入使用
 
使用方法：
maxlength：输入最大长度
isPwd：是否是密码模式
@finish：回调函数
 <validcode :maxlength="4" :isPwd="false" @finish="finish"></validcode>
 -->
<template>
	<div class="code-area">
		<div class="flex-box">
			<input
				type="number"
				:maxlength="maxlength"
				class="hide-input"
				v-model="val"
				@input="getVal"
				@focus="getFocus"
				@blur="codeIndex = 0"
			/>
			<div :class="['itemVcode', { active: codeIndex == 1 }]">
				<div class="line"></div>
				<template v-if="isPwd && codeArr.length >= 1">
					<span class="dot">.</span>
				</template>
				<template v-else>{{ codeArr[0] ? codeArr[0] : ''}}</template>
			</div>
			<div :class="['itemVcode', { active: codeIndex == 2 }]">
				<div class="line"></div>
				<template v-if="isPwd && codeArr.length >= 2">
					<span class="dot">.</span>
				</template>
				<template v-else>{{ codeArr[1] ? codeArr[1] : ''}}</template>
			</div>
			<div :class="['itemVcode', { active: codeIndex == 3 }]">
				<div class="line"></div>
				<template v-if="isPwd && codeArr.length >= 3">
					<span class="dot">.</span>
				</template>
				<template v-else>{{ codeArr[2] ? codeArr[2] : ''}}</template>
			</div>
			<div :class="['itemVcode', { active: codeIndex == 4 }]">
				<div class="line"></div>
				<template v-if="isPwd && codeArr.length >= 4">
					<span class="dot">.</span>
				</template>
				<template v-else>{{ codeArr[3] ? codeArr[3] : ''}}</template>
			</div>
			<template v-if="maxlength === 6">				
				<div :class="['itemVcode', { active: codeIndex == 5 }]">
					<div class="line"></div>
					<template v-if="isPwd && codeArr.length >= 5">
						<span class="dot">.</span>
					</template>
					<template v-else>{{ codeArr[4] ? codeArr[4] : ''}}</template>
				</div>
				<div :class="['itemVcode', { active: codeIndex == 6 }]">
					<div class="line"></div>
					<template v-if="isPwd && codeArr.length >= 6">
						<span class="dot">.</span>
					</template>
					<template v-else>{{ codeArr[5] ? codeArr[5] : ''}}</template>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	props:['maxlength','isPwd','reTime'],
	data() {
		return {
			codeIndex: 0, //下标
			codeArr: [],
			val:'',//输入框的值
		};
	},
	methods: {
		//设置获取焦点时光标的位置
		getFocus(e){
			let value = this.val
			let arr = value.split('');
			this.codeIndex = arr.length + 1;
		},
		//取值
		getVal(e) {
			let value = this.val
			if(typeof this.reTime == 'function'){
				this.reTime()
			}
			let arr = value.split('');
			this.codeIndex = arr.length + 1;
			this.codeArr = arr;
			if (this.codeIndex > Number(this.maxlength)) {
				//输入完成
				this.$emit('finish',this.codeArr.join(''));
			}
		},
	}
};
</script>

<style lang="less">
.code-area {
	text-align: center;
	.flex-box {
		display: flex;
		position: relative;
		.itemVcode {
			flex-shrink: 0;
			position: relative;
			color: #333;
			font-size: 0.3rem;
			font-weight: bold;
			// box-sizing: border-box;
			height: 0.68rem;
			line-height: 0.68rem;
			width: 0.69rem;
			border-right: 0.02rem solid #ddd;
			&:last-child{
				border-right: none;
			}
			.dot{
				font-size: 0.4rem;
				line-height: 0.35rem;
			}
			.line {
				display: none;
				position: absolute;
				left: 50%;
				top: 50%;
				// transform: translate(-50%, -50%);
				width: 0.02rem;
				height: 0.35rem;
				margin-top: -0.175rem;
				background: #31a3dc;
				animation: twinkling 1s infinite ease;
			}
			&.active{
				.line {
					display: block;
				}
			} 
		}
		
		.hide-input {
			position: absolute;
			top: 0;
			left: -100%;
			width: 200%;
			height: 100%;
			min-height: 100%;
			text-align: left;
			z-index: 9;
			opacity: 0;
		}

		@keyframes twinkling {
			0% {
				opacity: 0.2;
			}
			50% {
				opacity: 0.5;
			}
			100% {
				opacity: 0.2;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/assets/validCode.vue